var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"type":_vm.type,"icon":_vm.icon,"color":_vm.color}},[_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }